import { styled } from '@abyss/web/tools/styled';
import { Drawer } from '@abyss/web/ui/Drawer';

import { mobileOnly, notMobile } from '../../../ConstantsStyles';

export const primaryDropdownSearchIconColor = '#6F6F6F';

export const Divider = styled('div', {
  borderTop: `1px solid $lightGray`,
  height: '0px',
  marginLeft: '-24px',
  marginTop: '44px',
  width: 'calc(100% + 48px)',
});

export const DropdownPositionContainer = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
});

export const DropdownContentContainer = styled('div', {
  alignItems: 'flex-start',
  backdropFilter: 'blur(13.591408729553223px)',
  backgroundColor: 'white',
  borderRadius: '0px 0px 32px 32px',
  boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  top: 62,
  zIndex: 5,
  [`@media ${notMobile}`]: {
    padding: `16px 24px 12px`,
    gap: '12px',
  },
  [`@media ${mobileOnly}`]: {
    padding: `16px 23px 20px`,
    gap: '16px',
  },
  dynamic: ({ cssProps: { isGuestLocationSearch } }) => ({
    ...(isGuestLocationSearch
      ? {
          borderTop: '1px solid #CBCCCD',
          overflowY: 'auto',
          left: 0,
          width: '750px',
        }
      : {
          border: '1px solid #CBCCCD',
          right: 0,
          maxHeight: '430px',
          width: '451px',
          position: 'absolute',
        }),
  }),
});

export const isLocationActiveSuggetion = {
  boxShadow:
    'white 0px 0px 0px 2px, var(--abyss-psx-parcel-colors-interactive1) 0px 0px 2px 4px',
};

export const ChangeLocationDrawer = styled(Drawer, {
  '.abyss-modal-close-button': {
    top: 'var(--abyss-psx-parcel-space-md)',
    right: 'var(--abyss-psx-parcel-space-md)',
  },
  '.abyss-modal-content-title': {
    color: '$primary1',
    paddingTop: 'var(--abyss-psx-parcel-space-sm)',
    fontSize: '24px',
    fontWeight: '$semibold',
  },
  '.abyss-modal-header-container': {
    padding: '0px',
  },
  '.abyss-modal-body': {
    height: '100%',
    padding: '0 var(--abyss-psx-parcel-space-sm)',
  },
  '.abyss-modal-content-container': {
    borderRadius: '20px 20px 0px 0px',
    padding: '0 var(--abyss-psx-parcel-space-lg)',
    height: '100%',
  },
});

export const hiddenTextStyle = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: '0',
  margin: '-1px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  border: 0,
};

export const popoverStyles = {
  'abyss-popover-title': {
    fontSize: '24px !important',
    fontWeight: '$bold !important',
    color: '$primary1 !important',
  },
  'abyss-popover-content': {
    borderRadius: '8px !important',
    zIndex: 9,
  },
  'abyss-popover-content-container': {
    overflow: 'visible',
    padding: '5px',
  },
  'abyss-form-input-wrapper-container': {
    margin: '4px !important',
  },
};
